(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name flightDelayReport.controller:FlightDelayReportCtrl
	 *
	 * @description
	 *
	 */
	angular.module('flightDelayReport').controller('FlightDelayReportCtrl',
			FlightDelayReportCtrl);

	function FlightDelayReportCtrl(CommonMasterData, $sce, CommonLogicService) {
		var vm = this;
		vm.ctrlName = 'FlightDelayReportCtrl';

		// report types
		vm.reportTypes = {
			DELAY_CODE : 'DELAY_CODE',
			DELAY_CATEGORY : 'DELAY_CATEGORY'
		}

		vm.model = {
			searchPanelToggle : true,
			defaultCarrier : null,
			searchCriteria : {
				fromDate : null,
				toDate : null,
				origin : null,
				destination : null,
				reportType : false,
				carriers : null
			},
			masterList : {
				fromDateFormatInvalid : false,
				toDateFormatInvalid : false,
				fromDateAfterToDate : false,
				carriers : []
			},
			initialSearchDone : false,
			reportDataURL : null,
			reportServerBaseUrl : null
		};

		// toggle search
		vm.clickOnSearch = function() {
			vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
			vm.model.initialSearchDone = false;
		};

		// submit search
		vm.submitSearch = function(params) {
			searchFlightDelayReport(params);
		};

		// when change field in search
		vm.changeSearchField = function(searchParams, flag) {
			setDateValidationFlags();
			if (!vm.model.masterList.toDateFormatInvalid
					&& !vm.model.masterList.fromDateFormatInvalid) {
				if (istoDateBeforeFromDate()) {
					vm.model.masterList.fromDateAfterToDate = true;
				} else {
					vm.model.masterList.fromDateAfterToDate = false;
				}
			} else {
				vm.model.masterList.fromDateAfterToDate = false;
			}
		};

		function setDateValidationFlags() {
			// if from date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
				vm.model.masterList.fromDateFormatInvalid = true;
			} else {
				vm.model.masterList.fromDateFormatInvalid = false;
			}

			// if to date invalid
			if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
				vm.model.masterList.toDateFormatInvalid = true;
			} else {
				vm.model.masterList.toDateFormatInvalid = false;
			}
		}

		// validate Date
		function isDateFormatInvalid(date) {
			if (!!date && !moment(date, "DD/MM/YYYY").isValid()) {
				return true;
			}
		}
		;

		// check from date and to date
		function istoDateBeforeFromDate() {
			return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
					.isBefore(
							moment(vm.model.searchCriteria.fromDate,
									"DD/MM/YYYY"));
		}
		;

		// search daily ops report
		function searchFlightDelayReport(param) {
			vm.model.initialSearchDone = true;
			if (isValidSearchParams(param)) {
				vm.model.searchCriteria = param;
				vm.model.searchPanelToggle = false;
				var url = CommonLogicService.getReportUrl(
						"flight_delay_report.rptdesign",
						getSearchParamMap(param));
				vm.model.reportDataURL = $sce.trustAsResourceUrl(url);
			}
		}

		// set search param map
		function getSearchParamMap(param) {
			var searchParamMap = {};
			searchParamMap["fromDate"] = param.fromDate;
			searchParamMap["toDate"] = param.toDate;
			searchParamMap["reportType"] = getReportType(param.reportType);
			searchParamMap["origin"] = '';
			if (!!param.origin && !!param.origin.airPortCode) {
				searchParamMap["origin"] = param.origin.airPortCode;
			}
			searchParamMap["destination"] = '';
			if (!!param.destination && !!param.destination.airPortCode) {
				searchParamMap["destination"] = param.destination.airPortCode;
			}
			
			searchParamMap["carrier"] = '';
		    if (!!param.carriers && !!param.carriers.code) {
		        searchParamMap["carrier"] = param.carriers.code;
		    }
		    
			return searchParamMap;
		}

		function getReportType(reportType) {
			if (reportType) {
				return vm.reportTypes.DELAY_CODE;
			} else {
				return vm.reportTypes.DELAY_CATEGORY;
			}
		}

		function isValidSearchParams(params) {
			setDateValidationFlags();
			if (!!vm.model.searchCriteria.fromDate
					&& !vm.model.masterList.fromDateFormatInvalid
					&& !!vm.model.searchCriteria.toDate
					&& !vm.model.masterList.toDateFormatInvalid
					&& !vm.model.masterList.fromDateAfterToDate) {
				return true;
			}
			return false;
		}
		(function() {
			// load airport list
			CommonMasterData.getAirportList(function(airportList) {
				vm.model.masterList.airportList = airportList;
			}, function(error) {
				console.log('Airport List retrieval error!!!');
			});
			
			CommonMasterData.searchCarriers( 
		              function (response) {
		              	for(var index in response.hubCodes) {
		              		vm.model.masterList.carriers.push({"code":response.hubCodes[index],"name":response.hubCodes[index]});
		              	}
		              	vm.model.defaultCarrier = response.clientCode;
		              },
		              function (error) {
		                MessageService.error(error);
		              }
		     );

		})();
	}
}());
